// extracted by mini-css-extract-plugin
module.exports = {"ErrorModal":"ErrorModal_ErrorModal__1gKKo","Open":"ErrorModal_Open__31794","Close":"ErrorModal_Close__D6dOW","Brand":"ErrorModal_Brand__3pNPu"};